import { render, staticRenderFns } from "./examPoints.vue?vue&type=template&id=4354406c&scoped=true&"
import script from "./examPoints.vue?vue&type=script&lang=js&"
export * from "./examPoints.vue?vue&type=script&lang=js&"
import style0 from "./examPoints.vue?vue&type=style&index=0&id=4354406c&prod&scoped=true&lang=scss&"
import style1 from "./examPoints.vue?vue&type=style&index=1&id=4354406c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4354406c",
  null
  
)

export default component.exports